export function searchByName(events: any[], filterText: string): any[] {
  return events.filter((e: any) => {
    return e.eventName.toLowerCase().includes(filterText.toLowerCase());
  });
}
